import React, { useState } from "react";
import logo from "../Assets/oz-hayun.png";
import { FaLinkedin, FaGithub, FaBars, FaTimes } from "react-icons/fa";
import { useEvent } from "../hooks/useEvent";
import { ANALYTICS_EVENTS, NAV_SECTIONS, SOCIAL_PLATFORMS } from "../Constants/analyticsEvents";
import { scrollToSection } from "../lib/lenis";
import Magnetic from "./Magnetic";

const NAV_LINKS = [
  { id: "about", label: "About", section: NAV_SECTIONS.ABOUT },
  { id: "experience", label: "Experience", section: NAV_SECTIONS.EXPERIENCE },
  { id: "education", label: "Education", section: NAV_SECTIONS.EDUCATION },
  { id: "projects", label: "Projects", section: NAV_SECTIONS.PROJECTS },
  { id: "skills", label: "Skills", section: NAV_SECTIONS.SKILLS },
  { id: "contact-me", label: "Contact", section: NAV_SECTIONS.CONTACT },
];

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const track = useEvent();

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleNavClick = (id, section) => {
    track(ANALYTICS_EVENTS.NAV_CLICK, { section });
    const offsetValue = window.innerWidth >= 1024 ? -80 : -20;
    scrollToSection(id, offsetValue);
    setIsOpen(false);
  };

  return (
    <nav className="glass-nav fixed top-0 left-0 z-50 w-full py-2">
      <div className="container px-4 mx-auto">
        <div className="flex items-center justify-between">
          <button
            type="button"
            className="flex-shrink-0 cursor-pointer"
            onClick={() => handleNavClick("about", NAV_SECTIONS.ABOUT)}
          >
            <img src={logo} alt="Oz Hayun home" className="w-auto h-16" />
          </button>

          <div className="flex items-center space-x-4 text-xl text-biolum-green">
            <Magnetic>
              <a
                href="https://www.linkedin.com/in/ozhayun/"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-biolum-blue transition-colors duration-300"
                onClick={() => track(ANALYTICS_EVENTS.SOCIAL_CLICK, { platform: SOCIAL_PLATFORMS.LINKEDIN })}
              >
                <FaLinkedin />
              </a>
            </Magnetic>
            <Magnetic>
              <a
                href="https://github.com/ozhayun"
                target="_blank"
                rel="noopener noreferrer"
                className="hover:text-biolum-blue transition-colors duration-300"
                onClick={() => track(ANALYTICS_EVENTS.SOCIAL_CLICK, { platform: SOCIAL_PLATFORMS.GITHUB })}
              >
                <FaGithub />
              </a>
            </Magnetic>
            <button
              type="button"
              aria-label={isOpen ? "Close menu" : "Open menu"}
              aria-expanded={isOpen}
              className="lg:hidden text-2xl cursor-pointer text-biolum-green hover:text-biolum-blue transition-colors duration-300"
              onClick={toggleMenu}
            >
              {isOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}
            </button>
          </div>
        </div>
        <div
          className={`flex-col lg:flex-row lg:flex justify-center items-center mt-2 lg:mt-0 ${
            isOpen ? "flex" : "hidden"
          } lg:flex lg:space-x-4 text-base`}
        >
          <ul className="lg:flex-row lg:space-y-0 lg:space-x-4 flex flex-col space-y-2 text-base">
            {NAV_LINKS.map(({ id, label, section }) => (
              <li key={id}>
                <Magnetic strength={0.25}>
                  <button
                    type="button"
                    className="hover:font-bold cursor-pointer text-slate-300 hover:text-biolum-green transition-colors duration-300"
                    onClick={() => handleNavClick(id, section)}
                  >
                    {label}
                  </button>
                </Magnetic>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
}
